export function BackNavIcon({ className }: { className: string }) {
  return (
    <svg
      className={className}
      width="62"
      height="40"
      viewBox="0 0 62 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.4111 0.5H41.2373C52.0069 0.5 60.7373 9.23045 60.7373 20C60.7373 30.7696 52.0069 39.5 41.2373 39.5H29.4111C24.2146 39.5 21.702 39.4961 19.3623 38.9043C17.1991 38.3571 15.1458 37.443 13.292 36.2012C11.2869 34.858 9.60333 32.9925 6.12695 29.1299L5.65527 28.6055C4.12564 26.9059 3.00007 25.6546 2.19434 24.5859C1.39298 23.5231 0.934964 22.6749 0.717773 21.793C0.427807 20.6152 0.427807 19.3848 0.717773 18.207C0.934964 17.3251 1.39298 16.4769 2.19434 15.4141C3.00007 14.3454 4.12564 13.0941 5.65527 11.3945L6.12695 10.8701C9.60333 7.00747 11.2869 5.14204 13.292 3.79883C15.1458 2.55702 17.1991 1.64292 19.3623 1.0957C21.702 0.503887 24.2146 0.5 29.4111 0.5Z"
        stroke="currentColor"
      />
    </svg>
  );
}
